import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { VisuallyHidden } from "@air/primitive-visually-hidden";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
import { getContrastColor } from "~/components/v2/utils/filters/getContrastColor";
export const CustomColorValue = /*#__PURE__*/ memo((param)=>{
    let { className, hex, isSelected, onSelect, onRemoveHex, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("relative flex h-6 items-center gap-1 rounded-24 border border-grey-5 px-1 uppercase ring-0 transition-colors data-[selected=true]:border-grey-10 data-[selected=true]:ring-1 data-[selected=true]:ring-grey-10 hover:bg-grey-4 data-[selected=true]:hover:bg-grey-4", className),
        "data-selected": isSelected,
        "data-hex": hex,
        "data-testid": "CUSTOM_COLOR_CHIP",
        ...restOfProps,
        children: [
            /*#__PURE__*/ _jsx("button", {
                className: "absolute inset-0 size-full",
                onClick: onSelect,
                children: /*#__PURE__*/ _jsxs(VisuallyHidden, {
                    children: [
                        "Select ",
                        hex
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex size-4 items-center justify-center rounded-full",
                style: {
                    backgroundColor: hex
                },
                children: isSelected && /*#__PURE__*/ _jsx(Check, {
                    className: "size-3",
                    style: {
                        color: getContrastColor(hex)
                    }
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "text-12 font-medium text-grey-12",
                children: hex
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                "data-hex": hex,
                "data-testid": "CUSTOM_COLOR_REMOVE_BUTTON",
                icon: Close,
                label: "Remove ".concat(hex),
                onClick: onRemoveHex,
                size: "extra-small"
            })
        ]
    });
});
CustomColorValue.displayName = "CustomColorValue";
